export const trainerQueryKeys = {
  all: () => "trainer"
};
